import { render, staticRenderFns } from "./raise-ticketPrices-edit.vue?vue&type=template&id=31f0d952&"
import script from "./raise-ticketPrices-edit.vue?vue&type=script&lang=js&"
export * from "./raise-ticketPrices-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports